import { formatStreet } from "@components/store-locator/utils/formatAddress";
import { activeSiteCountry } from "@config/site/site-config";
import type { CheckoutFormInitialValues } from "../types";
import { shapeParcelShopCustomFields } from "@lib/utils/cartProductUtility";
import type { StoreData } from "@features/stores/types";
import { getPostalCodeFormatter } from "./formatting/getPostalCodeFormatter";

const getBasicDeliveryAddress = (
    store: StoreData
): CheckoutFormInitialValues["deliveryAddress"] => {
    const deliveryAddress = {
        city: store.city,
        streetName: formatStreet(store),
        postalCode: store.postalCode,
        region: store.region,
        country: store.countryCode,
        additionalAddressInfo: "",
    };

    return {
        city: deliveryAddress.city,
        streetName: deliveryAddress.streetName,
        postalCode: deliveryAddress.postalCode,
        region: deliveryAddress.region,
        country: deliveryAddress.country,
        additionalAddressInfo: deliveryAddress.additionalAddressInfo,
    };
};

export const mapParcelShopToDeliveryAddress = (
    store: StoreData
): CheckoutFormInitialValues["deliveryAddress"] => {
    const basicDeliveryAddress = getBasicDeliveryAddress(store);
    const customFields = shapeParcelShopCustomFields(store);

    return {
        ...basicDeliveryAddress,
        customFields: customFields,
    };
};

export const mapClickAndCollectStoreToDeliveryAddress = (
    store: StoreData
): CheckoutFormInitialValues["deliveryAddress"] => {
    const basicDeliveryAddress = getBasicDeliveryAddress(store);
    const postalCodeFormatter = getPostalCodeFormatter(activeSiteCountry);

    return {
        ...basicDeliveryAddress,
        postalCode: postalCodeFormatter(basicDeliveryAddress.postalCode || ""),
    };
};
